<template>
  <v-row>
    <v-col cols="12">
      <v-dialog v-model="dialog" persistent max-width="70%">
        <v-card>
          <v-card-title class="text-h5">
            <!-- {{ title }} -->
            Payment Details
          </v-card-title>

          <v-card-text class="px-0">
            <v-data-table
              :headers="table.headers"
              :items="table.data"
              :items-per-page="10"
              :loading="table.loading"
              item-key="id"
              loading-text="Loading... Please wait"
              class="elevation-1"
            >
              <template v-slot:[`item.amount`]="{ item }">
                {{ item.amount.toLocaleString() }}
              </template>

              <template v-slot:[`item.name`]="{ item }">
                {{ item.name ? item.name : "-" }}
              </template>
              <template
                v-for="header in table.headers.filter((header) =>
                  header.hasOwnProperty('formatter')
                )"
                v-slot:[`item.${header.value}`]="{ value }"
              >
                {{ header.formatter(value) }}
              </template>
            </v-data-table>
          </v-card-text>

          <v-card-actions class="pb-5">
            <v-spacer></v-spacer>
            <!-- <v-btn text @click.native="cancel">
                No
              </v-btn> -->
            <v-btn @click.native="cancel">
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
import ShareableMethods from "@/mixins/ShareableMethods";

export default {
  mixins: [ShareableMethods],
  data() {
    return {
      exportData: [],
      fileName: "",

      dialog: false,
      resolve: null,
      reject: null,
      // message: null,
      // title: null,
      // options: {
      //   color: "grey lighten-3",
      //   width: 400,
      //   zIndex: 200,
      //   noconfirm: false,
      // },

      table: {
        // sortBy: "dtCreated",
        sortDesc: true,
        loading: false,

        headers: [],
        data: [],
      },
    };
  },

  methods: {
    open(data, type) {
      this.dialog = true;
      this.table.data = [];


      if(type == 'DIRECT_LOAD') {
        this.table.headers = [
          {
            text: "App Name",
            align: "start",
            value: "appName",
          },
          {
            text: "Reference Number",
            align: "start",
            value: "referenceNumber",
          },
          {
            text: "Mobile Number",
            align: "start",
            value: "mobileNumber",
          },
          {
            text: "Payment Method",
            align: "start",
            value: "paymentMethod",
          },
          {
            text: "Is Paid",
            align: "start",
            value: "isPaid",
          },
          {
            text: "Status",
            align: "start",
            value: "status",
          },
          {
            text: "Date Created",
            align: "start",
            sortable: false,
            value: "createdDate",
            formatter: (x) => (x ? this.formatDate(x) : null),
          },
        ];
      }else {
        this.table.headers = [
          {
            text: "Account Number",
            align: "start",
            value: "surfcoinsTopupData.accountNumber",
          },
          {
            text: "Amount",
            align: "start",
            value: "surfcoinsTopupData.amount",
          },
          {
            text: "Is Paid",
            align: "start",
            value: "surfcoinsTopupData.isPaid",
          },
          {
            text: "Status",
            align: "start",
            value: "surfcoinsTopupData.status",
          },
          {
            text: "Date Created",
            align: "start",
            sortable: false,
            value: "createdDate",
            formatter: (x) => (x ? this.formatDate(x) : null),
          },
        ];
      }


      const tableData = {
        ...data.paymentRecord,
        ...data.directLoadData,
        ...{ surfcoinsTopupData: data.surfcoinsTopupData },
      };

      console.log(tableData);
      this.table.data.push(tableData);

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    agree() {
      this.resolve(true);
      this.dialog = false;
    },
    cancel() {
      this.resolve(false);
      this.dialog = false;
    },

  },

  computed: {},
};
</script>
